import { defineNuxtPlugin } from '#app/nuxt'
import { setup } from '#build/nuxt-legacy/custom-polyfills.mjs'
if (import.meta.client) setup();
export default defineNuxtPlugin({
  name: 'custom-polyfills-plugin',
  setup (nuxtApp) {
  }
})